import React from 'react';
import { COMPANY_BRAND_NAME, COMPANY_TAGLINE } from '../../support/brand';
import { COMPANY_NAME, COMPANY_CNPJ } from '../../support/legal';
import {
  PANEL_LOGIN_URL,
  PANEL_PRIVACY_URL,
  PANEL_LEAD_URL,
  PANEL_TERMS_URL,
} from '../../support/publicUrls';

function PublicFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="relative border-t border-surface-border bg-white/50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-col items-center sm:items-start">
            <span className="text-sm font-bold text-content-primary">{COMPANY_BRAND_NAME}</span>
            <span className="text-[10px] text-forge-600 font-medium tracking-widest uppercase">
              {COMPANY_TAGLINE}
            </span>
          </div>

          <nav className="flex flex-wrap items-center justify-center gap-4">
            <a href="/agente-ia-whatsapp" className="text-sm text-content-muted hover:text-content-primary transition-colors">
              Agente de IA para WhatsApp
            </a>
            <a href="/mentor-ia" className="text-sm text-content-muted hover:text-content-primary transition-colors">
              Mentoria digital no WhatsApp
            </a>
            <a href="/artigos" className="text-sm text-content-muted hover:text-content-primary transition-colors">
              Artigos sobre agentes de IA
            </a>
            <a href={PANEL_LOGIN_URL} className="text-sm text-content-muted hover:text-content-primary transition-colors">
              Entrar
            </a>
            <a href={PANEL_LEAD_URL} className="text-sm text-content-muted hover:text-content-primary transition-colors">
              Criar conta
            </a>
            <a href={PANEL_PRIVACY_URL} className="text-sm text-content-muted hover:text-content-primary transition-colors">
              Política de Privacidade
            </a>
            <a href={PANEL_TERMS_URL} className="text-sm text-content-muted hover:text-content-primary transition-colors">
              Termos de Uso
            </a>
          </nav>

          <div className="flex flex-col items-center sm:items-end text-xs text-content-subtle">
            <p>{`© ${year} ${COMPANY_BRAND_NAME}`}</p>
            <p>{`${COMPANY_NAME} · CNPJ ${COMPANY_CNPJ}`}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default PublicFooter;
